import {PartCategoryApiDto} from "./_RestModels";

export default class PartCategory {
    constructor(public readonly id: string, public readonly name: string) {
    }

    public static fromJson(json: PartCategoryApiDto): PartCategory {
        return new PartCategory(json.id, json.name);
    }
}